import { AfterViewInit, Component, ElementRef, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { EventEmitter } from '@angular/core';
import { MarketSeaProductsModel } from 'src/app/models/sea/market-sea-products.model';
import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { SearchLogClickHistoryService } from 'src/app/services/search-log-click-history.service';

export interface ReservationData {
  selectedProduct: MarketSeaProductsModel | null;
  marketProductsDefId: number | null;
  productId: number | null;
  uuid: string | null;
}


@Component({
  selector: 'app-sea-card',
  templateUrl: './sea-card.component.html',
  styleUrls: ['./sea-card.component.scss'],
})


export class SeaCardComponent implements AfterViewInit{

  @Input() model: SeaModel = null;
  @Input() loading: boolean = false;
  @Input() alternativeSegmentStartIndex: number = null;
  
  @Output() makeReservation: EventEmitter<ReservationData> = new EventEmitter<ReservationData>();
  @Output() priceInfo: EventEmitter<MarketSeaProductsModel> = new EventEmitter<MarketSeaProductsModel>();
  @Output() priceRequest: EventEmitter<MarketSeaProductsModel> = new EventEmitter<MarketSeaProductsModel>();
  @Output() frontTariffNotFound: EventEmitter<any> = new EventEmitter<any>();
  @Output() endTariffNotFound: EventEmitter<any> = new EventEmitter<any>();
  @Output() frontEndTariffNotFound: EventEmitter<any> = new EventEmitter<any>();

  loaderOptions: AnimationOptions = {path: '/assets/lottie/load-price.json'};
  laoderStyles: Partial<CSSStyleDeclaration> = {width: '30px',margin: '0 auto',};


  

  @ViewChildren('details') detailsElements: QueryList<ElementRef>;

  constructor(public translation: TranslateService, private searchLogHistoryService: SearchLogClickHistoryService) {

  }

  ngAfterViewInit() {
    // ViewChildren burada güvenli bir şekilde kullanılabilir
  }
  

  toggleDetailsById(productId: string): void {
    const detailsEl = this.detailsElements.find(
      (el) => el.nativeElement.getAttribute('data-product-id') === productId
    );

    if (!detailsEl) return;

    const element = detailsEl.nativeElement;
    const isExpanded = element.classList.contains('expanded');

    if (isExpanded) {
      element.style.maxHeight = '0';
      element.classList.remove('expanded');
    } else {
      element.style.maxHeight = element.scrollHeight + 'px';
      element.classList.add('expanded');
    }
}

  _makeReservation(selectedProduct: MarketSeaProductsModel = null, marketProductsDefId = null, productId = null, uuid = null) {
    this.loading = true;
    this.makeReservation.emit({selectedProduct,marketProductsDefId,productId, uuid})
  }
  async _priceInfo(product: MarketSeaProductsModel) {
    if(product?.freights.errorCode) return;
    const history = await this.createClickHistory(product);
    product.history = history;
    this.priceInfo.emit(product)
  }
  _priceRequest(product:MarketSeaProductsModel ) {
    this.priceRequest.emit(product)
  }
  _frontTariffNotFound() {
    this.frontTariffNotFound.emit(null);
  }
  _endTariffNotFound() {
    this.endTariffNotFound.emit(null);
  }
  _frontEndTariffNotFound() {
    this.frontEndTariffNotFound.emit(null);
  }


  async createClickHistory(product: MarketSeaProductsModel) {
    const model = new SearchLogClickHistoryModel();

    model.searchLogId = this.model?.id || null;
    model.productId = product?.id;
    model.productName = product?.name;
    model.uuid = product?.uuid;
    model.viewType = "PRODUCTVIEW";
    model.info = "CARDVIEW";

    return await this.searchLogHistoryService.create(model).toPromise();
  }

}
